import { useState } from 'react';
import { ArticleClient, ArticleDTO, ApiResponse_string, SearchRequestDTO_ArticleSearchRequestDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';
import { handleHookError } from '../utils/hookUtils/handleHookError';

export const useArticleApi = () => {
    const apiClient = new ArticleClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: ArticleDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createArticle(data);
        } catch (err: any) {
            setError(err.message || 'Error creating Article');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: ArticleDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateArticle(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating Article');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getArticleById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching Article');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchArticles(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching Articles');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteArticle(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting Article');
        } finally {
            setIsLoading(false);
        }
    };

    const extract = async (
        filters: any
    ): Promise<ApiResponse_string> => {
        setIsLoading(true);
        try {
            return await apiClient.exportArticles(filters);
        } catch (err: unknown) {
            handleHookError(err, 'Error exporting Articles', setError);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, extract, remove, isLoading, error };
};